// extracted by mini-css-extract-plugin
export var active = "_sh-1";
export var circle = "_sh-0";
export var completed = "_sh-2";
export var connector = "_sh-4";
export var connectorCompleted = "_sh-7";
export var connectorSpacer = "_sh-5";
export var iconStrokeOverride = "_sh-8";
export var labelContainer = "_sh-6";
export var pending = "_sh-3";